module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__bg-690ad38cbf023743913b6719b828bd4b.png";